import { ElementType, useState } from 'react'
import { Link } from 'react-router-dom'
import { Label } from '@mui/icons-material'
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material'
import { TreeProps } from './TreeProps.type'

interface ItemProps {
  title: string
  icon?: ElementType
  path?: string
  children?: ItemProps[]
}

const Item = (props: ItemProps) => {
  const { children, title, icon, path } = props
  const Icon = icon ?? Label

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <ListItem disablePadding sx={{ display: 'block' }}>
      <Tooltip enterDelay={1000} title={title}>
        <ListItemButton
          component={path ? Link : 'div'}
          disableRipple={!path}
          sx={{
            minHeight: 48,
            px: 2.5,
            justifyContent: 'center',
          }}
          data-path={path}
          to={path}
          onClick={children ? handleClick : undefined}
        >
          <ListItemIcon
            className="opacity-70"
            sx={{
              minWidth: 0,
              justifyContent: 'center',
              mr: 'auto',
            }}
          >
            <Icon />
          </ListItemIcon>
        </ListItemButton>
      </Tooltip>
      {children && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onClick={handleClose}
        >
          {children.map(({ title, icon: Icon = Label, path }, index) => (
            <MenuItem
              key={index}
              component={path ? Link : 'div'}
              to={path}
              onClick={handleClose}
            >
              <ListItemIcon>
                <Icon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={title} />
            </MenuItem>
          ))}
        </Menu>
      )}
    </ListItem>
  )
}

const CollapsedTree = (props: TreeProps) => {
  const { items } = props
  return (
    <List>
      {items?.map((item, index) => (
        <Item key={index} {...item} />
      ))}
    </List>
  )
}

export default CollapsedTree
